"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlatSaleLinkBannerMobile = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./style.css"));
var _uiKit = require("@cian/ui-kit");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FlatSaleLinkBannerMobile = _ref => {
  let {
    onClick,
    url
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: style['banner']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['info']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['info-block']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['info-text']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, {
    color: "text-inverted-default"
  }, "\u0412\xA0\u043D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0439\u043A\u0435\xA0\u2014 \u0432\u0441\u0451\xA0\u043F\u043E\u2011\u043D\u043E\u0432\u043E\u043C\u0443"), /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: "text-inverted-default"
  }, "\u0421\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u0430\u044F \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0430 \u0438 \u0441\u0432\u0435\u0436\u0430\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430"))), /*#__PURE__*/React.createElement("div", {
    className: style['button']
  }, /*#__PURE__*/React.createElement(_uiKit.LinkButton, {
    target: "_blank",
    onClick: onClick,
    href: url,
    theme: "fill_white_primary",
    size: "M",
    color: "current_color"
  }, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0439\u043A\u0443"))), /*#__PURE__*/React.createElement("div", {
    className: style['image']
  }));
};
exports.FlatSaleLinkBannerMobile = FlatSaleLinkBannerMobile;